import { Field, FieldProps } from 'formik'
import * as React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { IFormValues } from './PersonalInfoForm'

const InnerRadioButton = (props: {
  default: { label: string; value: string }
  name: string
  options: Array<{ label: string; value: string }>
}) => {
  const getRadioButton = (form: any): any => {
    const handleSelect = (event: any) => {
      form.setFieldValue(props.name, event.target.value)
    }
    const getOption = (opt: any) => {
      return (
        <div>
          <input defaultChecked={opt.label === props.default.label} type='radio' value={opt.value} name={props.name} />
          <span>{opt.label}</span>
        </div>
      )
    }
    return (
      <div className='flex flex-column' onChange={handleSelect}>
        {props.options &&
          Object.keys(props.options).map((item, i) => <div key={i}>{getOption(props.options[item])}</div>)}
      </div>
    )
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<IFormValues>) => <div className='mt1'>{getRadioButton(form)}</div>}
    </Field>
  )
}

export default InnerRadioButton



// WEBPACK FOOTER //
// ./src/components/riders/createrider/personalinfo/InnerRadioButton.tsx